






















import OverviewStorage from "@/components/OverviewStorage.vue";
import HitRate from "@/components/HitRate.vue";
import OverviewIssues from "@/components/OverviewIssues.vue";
import OverviewStats from "@/components/OverviewStats.vue";
import OverviewConnections from "@/components/OverviewConnections.vue";
import OverviewChart from "@/components/OverviewChart.vue";
import { Settings } from "@/types/settings";
import { STATS_LIFETIME } from "@/config/series";
import GetProcessedStats from "@/mixins/get-processed-stats";
import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    OverviewStorage,
    OverviewConnections,
    HitRate,
    OverviewIssues,
    OverviewChart,
    OverviewStats,
  },
})
export default class OverviewView extends Mixins(GetProcessedStats) {
  created() {
    this.getProcessedStats();

    if (this.settings.enabled) {
      this.$store.dispatch("stats/fetch");

      // Refetch data periodically
      this.intervalID = setInterval(() => {
        this.$store.dispatch("stats/fetch");
      }, STATS_LIFETIME);
    }
  }

  beforeDestroy() {
    // Refetch data clean up
    this.cleanUpProcessedStats();

    clearInterval(this.intervalID);
  }

  @Getter("settings/activeCacheSettings") settings!: Settings;

  intervalID = 0;
}
